
import MainLayout from '@/components/layout/MainLayout';
import SeshDebugger from '@/components/debug/SeshDebugger';

const SeshDebug = () => {
  return (
    <MainLayout>
      <SeshDebugger />
    </MainLayout>
  );
};

export default SeshDebug;
